<template>
    <views v-show="value" class="modal" @click="close">
        <views class="modal-content">
            <views class="modal-content-head">用户注册协议</views>
            <views class="modal-content-body" v-html="html"></views>
        </views>
    </views>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        html: {
            type: String,
            default: ''
        }
    },
    methods: {
        close() {
            this.$emit('input', false)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
    .modal{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        background: rgba(0,0,0,.8);
        &-content{
            position: absolute;
            left: 10%;
            top: 20%;
            width: 80%;
            height: 60%;
            background: #fff;
            border-radius: rpx($radius);
            padding: rpx(40);
            overflow: hidden;
            overflow-y: scroll;
            &-head{
                text-align: center;
                font-size: rpx(32);
                margin-bottom: rpx(40);
            }
            &-body{
                line-height: 1.5;
                font-size: rpx(26);
                color: #666;
            }
        }
    }
</style>
